var $ = window.jQuery = require('jquery');

import moment from 'moment';

export default {
  name: 'quiz-contest-popup',
  components: {},
  props: ['quizBannerData'],
  data () {
    return {
      quizData: '',
      loginLinkHide:true,
      loginLinkOff:true
    }
  },
  computed: {

  },
  mounted () {
    this.quizData = this.quizBannerData[0];
    $(document).ready(function() {
      $(".contest_hud_circle_name").on("mouseenter", function() {
        $(this).parents('.contest_hud_circle_inner').addClass("hover_effects");
      });
      $(".contest_hud_circle_name").on("mouseleave", function() {
        $(this).parents('.contest_hud_circle_inner').removeClass("hover_effects");
      });
    });
    if(localStorage.getItem('token')){
      this.loginLinkHide = false
    }else{
      this.loginLinkHide = true
    }
    if(this.$route.name == 'login'){
      this.loginLinkOff = false
    }else{
      this.loginLinkOff = true
    }
  },
  methods: {
    dateFormatNumbringFun(date) {
      var d = moment(date).utc().format('DD')
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
      }
    },
    timeConvert(duration) {
      let totalTime = duration / 60;
      let hours = Math.floor(totalTime / 60);
      let minutes = totalTime % 60;
      let formattedTime = '';
      if(hours < 1) {
        formattedTime += "";
      } else {
        formattedTime += `${hours} hour${hours > 1 ? 's':''}`;
      }
      if(minutes < 1) {
        formattedTime += "";
      } else {
        formattedTime += `${hours > 0 ? ' ':''}${minutes} minute${minutes > 1 ? 's':''}`;
      }
      return formattedTime;
    },
    loginBtnClickPopupClose(){
      $("body").removeClass('contest_popup_active')
      $(".quiz_contest_popup").removeClass('actv_contest')
      $(".quiz_contest_popup_wrp").removeClass('actv_contest_popup')
    }
  }
}
